import AOS from "aos";

import "./navigation";
import "./common";
import "./donation";
import "./video";
import "./needs";
import "./counters";

AOS.init({ disable: "mobile" });







